<template>
  <div class="SayfaContainer">
    <div class="SayfaBaslik">
      <h1>{{ Bina }} Binası</h1>
      <div class="SayfaBtn el-button-group">
        <el-button size="small" type="default" @click="SayfaYukle" :disabled="lo">YENİLE</el-button>
        <el-button size="small" type="default" @click="YeniAsansor" :disabled="lo">ASANSÖR EKLE</el-button>
        <el-button size="small" type="default" @click="BinaDuzenle" :disabled="lo">BİNAYI DÜZENLE</el-button>
      </div>
    </div>

    <div class="SayfaIcerik" v-loading="lo">
      <el-col :sm="24" :md="4" class="pr-10">
        <table class="table table-sm bilgi-table">
          <thead>
          <tr>
            <th>Bina Bilgi</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <small class="d-block">Adı</small>
              {{ Data.adi }}
            </td>
          </tr>
          <tr>
            <td>
              <small class="d-block">Adres</small>
              {{ Data.adres }}
            </td>
          </tr>
          <tr>
            <td>
              <small class="d-block">Bölge</small>
              {{ Data.Bolge.adi }}
            </td>
          </tr>
          <tr>
            <td>
              <small class="d-block">Vergi No/Daire</small>
              {{ Data.vno }} / {{ Data.vdaire }}
            </td>
          </tr>
          <tr>
            <td>
              <small class="d-block">Yetkili/Yetkili Telefon</small>
              {{ Data.yadi }} / {{ Data.ytelefon }}
            </td>
          </tr>
          </tbody>
        </table>
      </el-col>

      <el-col :sm="24" :md="10" class="pr-10">
        <el-table
            :data="Data.Bakim"
            class="table-xs table-hover"
            :height="Height"
        >
          <el-table-column label="Tarih" prop="tarih"></el-table-column>
          <el-table-column label="Bakım" prop="adi"></el-table-column>
          <el-table-column label="Açıklama" prop="aciklama" align="right"></el-table-column>
          <el-table-column label="Asansör" prop="asansor" align="right"></el-table-column>
        </el-table>
      </el-col>

      <el-col :sm="24" :md="10" class="pr-10">
        <el-table
            :data="Data.Asansor"
            class="table-xs table-hover"
            :height="Height"
        >
          <el-table-column label="No." prop="id" width="50"></el-table-column>
          <el-table-column label="Tarih" prop="tarih" width="100"></el-table-column>
          <el-table-column label="Barkod" prop="barkod" width="100"></el-table-column>
          <el-table-column label="M.Durum" prop="MDurum"></el-table-column>
          <el-table-column label="Üretim Yılı" prop="Uyili" width="100" align="right"></el-table-column>
          <el-table-column width="100" align="right">
            <template slot-scope="scope">
              <el-button
                  size="mini"
                  @click="AsansorEdit(scope.$index, scope.row)">Düzenle
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>

    </div>

    <AsansorModal :Bilgi="Bilgi" :Tur="Tur" :Durum="AsansorModalDurum" @Durum="SayfaYukle"></AsansorModal>
    <BinaModal :Bilgi="BinaBilgi" :Tur="Tur" :Durum="BinaModalDurum" @Durum="SayfaYukle"></BinaModal>
  </div>
</template>

<script>

import XLSX from 'xlsx';

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
  name: XLSX.utils.encode_col(i),
  key: i
}));

import AsansorModal from "./Comp/AsansorModal";
import BinaModal from "./Comp/BinaModal";

export default {
  components: {BinaModal, AsansorModal},
  data() {
    return {
      lo: false,
      AsansorModalDurum: false,
      BinaModalDurum: false,
      Tur: 'Post',
      Data: {
        adi: '',
        adres: '',
        Bolge: '',
        vno: '',
        vdaire: '',
        yadi: '',
        ytelefon: '',
      },
      Bina: '...',
      Height: null,
      BinaBilgi: null,
      Bilgi: null
    }
  },
  methods: {
    SayfaYukle() {
      this.AsansorModalDurum = false
      this.BinaModalDurum = false
      this.lo = true
      this.$store.dispatch("Get", {path: 'build/' + this.$route.params.Bina_id})
          .then(response => {
            if (response.Durum === "OK") {
              this.Data = response.Data
              this.Bina = response.Data.adi
              this.lo = false
              this.$store.dispatch("title", this.Bina);
            } else {
              this.$notify.error({
                title: response.Mesaj,
                customClass: 'error'
              });
              this.lo = false
            }
          })
    },
    AsansorEdit(index, row) {
      this.Tur = 'Put'
      this.Bilgi = row
      this.AsansorModalDurum = true
    },
    YeniAsansor() {
      this.Bilgi = {}
      this.Tur = 'Post'
      this.AsansorModalDurum = true
    },
    BinaDuzenle() {
      this.BinaBilgi = this.Data
      this.Tur = 'Put'
      this.BinaModalDurum = true
    },
  },
  created() {
    this.SayfaYukle()
    this.Height = window.innerHeight - 121
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Bina/BinaDetay.vue